import { Outlet, useLocation } from "react-router-dom";
import MenuLateral from "./menuLateral/MenuLateral";
import Header from "./header/Header";
import CalendarioAlunoLateral from "./CalendarioLateralAluno/CalendarioLateralAluno";
import TermosModal from "./termosModal/TermosModal";
import SemTurma from "../pages/semTurma/SemTurma";
import { useAuth } from "../auth/AuthContext";
import "./Layout.scss";

function getUsuario() {
  try {
    return JSON.parse(localStorage.getItem("usuario") || "null");
  } catch {
    return null;
  }
}

export default function Layout() {
  const location = useLocation();
  const usuario = getUsuario();
  const { recarregarUsuario } = useAuth();

  const tipoUsuario = String(usuario?.tipo || "").toLowerCase();

  // Bloqueia navegação e exibe SemTurma:
  // - Coordenador sem coordenação vinculada.
  // - Responsável sem turma vinculada.
  const coordSemCoordenacao =
    tipoUsuario === "coordenador" &&
    Array.isArray(usuario?.coordenacoesComoCoordenador) &&
    usuario.coordenacoesComoCoordenador.length === 0;
  const respSemTurma =
    tipoUsuario === "responsavel" &&
    Array.isArray(usuario?.turmas) &&
    usuario.turmas.length === 0;
  const usuarioSemVinculo = coordSemCoordenacao || respSemTurma;
  const coordenadorSemVinculo = usuarioSemVinculo;

  // Visão aluno (com calendário lateral) é exclusiva de aluno. Responsáveis têm fluxo próprio.
  const usuarioPodeUsarVisaoAluno = tipoUsuario === "aluno";

  const rotaComVisaoAluno =
    location.pathname === "/dashboard" ||
    location.pathname.startsWith("/detalhe-calendario-aluno");

  const usarLayoutAluno = usuarioPodeUsarVisaoAluno && rotaComVisaoAluno;

  return (
    <div className="app-layout">
      <MenuLateral />

      <div className={`app-layout__main ${usarLayoutAluno ? "is-aluno" : ""}`}>
        <div className="app-layout__center">
          <Header isAluno={usarLayoutAluno} />

          <div className="app-layout__body">
            <main key={location.pathname} className="app-layout__content">
              {coordenadorSemVinculo ? <SemTurma /> : <Outlet />}
            </main>
          </div>
        </div>

        {usarLayoutAluno && (
          <aside className="app-layout__right">
            <CalendarioAlunoLateral />
          </aside>
        )}
      </div>

      <TermosModal usuario={usuario} onAceito={recarregarUsuario} />
    </div>
  );
}
